module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Raymond Pelly is an Anglican Priest & theologian resident (since 1977) in Aotearoa, New Zealand. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Born in London in 1938, where he experienced the Blitz, he has worked as a teacher in Cambridge (UK), Boston/Cambridge (MA), Auckland (NZ). He is married to Barbara Craig, father of six children, two deceased. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("His book, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pilgrim to Unholy Places")]), _vm._v(", investigates the implications of the Holocaust for Jewish-Christian dialogue and belief generally. His Heartscape poems explore ‘deep mind’, the well-springs of passionate creativity and a strong love that embraces people as well as land and seascape. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Raymond speaks French & German; some of his best writing has been done in Contemplative/Carmelite Communities in Berlin, Weimar, Dachau & Esterwegen/Emsland.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8f72e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB.vue
// module id = 57
// module chunks = 0